// Estilos da aba "Parâmetros" da tela de config da Central de Alertas.
// Mesmo esqueleto da aba Inteligentes: um Paper com uma LINHA por parâmetro
// (ícone + nome + descrição + valor em vigor à esquerda, MetricInfo e campo à
// direita) e um rodapé único de salvamento — os dois parâmetros vão no mesmo
// POST, que o backend já aceita.

const styles = (theme) => ({
	pilha: {
		display: "flex",
		flexDirection: "column",
		gap: 2,
	},
	container: {
		display: "flex",
		flexDirection: "column",
		gap: 1,
		p: "16px",
		borderRadius: "16px",
		backgroundColor: theme.palette.background.paper,
	},
	intro: {
		color: theme.palette.text.secondary,
		maxWidth: "900px",
	},
	divisorTopo: {
		mt: 1,
	},
	linha: {
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-start",
		justifyContent: "space-between",
		gap: 3,
		py: 1.75,
		px: 1,
	},
	conteudo: {
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-start",
		gap: "12px",
		flexGrow: 1,
		minWidth: 0,
	},
	iconeParametro: {
		color: theme.palette.text.secondary,
		fontSize: 20,
		mt: "2px",
		flexShrink: 0,
	},
	textos: {
		display: "flex",
		flexDirection: "column",
		gap: "2px",
		minWidth: 0,
	},
	nome: {
		fontWeight: 500,
	},
	legenda: {
		color: theme.palette.text.secondary,
		display: "block",
	},
	linhaVigente: {
		display: "flex",
		flexDirection: "row",
		flexWrap: "wrap",
		alignItems: "baseline",
		gap: "6px",
		mt: "4px",
	},
	rotuloVigente: {
		color: theme.palette.text.secondary,
	},
	valorVigente: {
		fontWeight: 600,
	},
	controles: {
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-start",
		gap: "8px",
		flexShrink: 0,
	},
	// Alinha o ⓘ com a primeira linha do campo (o TextField tem 40px).
	espacoInfo: {
		mt: "5px",
	},
	campo: {
		width: "220px",
	},
	aviso: {
		alignItems: "flex-start",
		mx: 1,
	},
	observacao: {
		color: theme.palette.text.secondary,
		px: 1,
	},
	// Rodapé único: estado das alterações à esquerda, ações à direita.
	rodape: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		gap: 2,
		p: "12px 16px",
		borderRadius: "16px",
		backgroundColor: theme.palette.background.paper,
	},
	estadoRodape: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		gap: "10px",
		minWidth: 0,
	},
	// Ponto de estado: nunca sozinho — sempre acompanhado do texto ao lado.
	pontoEstado: (cor) => ({
		width: 8,
		height: 8,
		borderRadius: "50%",
		backgroundColor: cor,
		flexShrink: 0,
	}),
	textosRodape: {
		display: "flex",
		flexDirection: "column",
		minWidth: 0,
	},
	tituloRodape: {
		fontWeight: 500,
	},
	detalheRodape: {
		color: theme.palette.text.secondary,
		display: "block",
	},
	acoesRodape: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		gap: 1,
		flexShrink: 0,
	},
});

export default styles;
